import React, { useContext } from 'react';
import _merge from 'lodash/merge';

import { getContext } from 'common';
import { CircularProgressIndicatorContext } from './CircularProgressIndicatorDeterminate';
import Styled from './styles';

export interface CircularProgressIndicatorOuterTextProps extends React.ComponentPropsWithRef<'div'> {
  /**  children, i.e. text to place outside the CircularProgressIndicatorDeterminate */
  children: string;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** CircularProgressIndicatorOuterText, all other props than `children` will be provided to the root DOM element */
const CircularProgressIndicatorOuterText = React.forwardRef<HTMLElement, CircularProgressIndicatorOuterTextProps>((props: CircularProgressIndicatorOuterTextProps, ref) => getContext(({ theme }) => {
  const {
    children,
    theme: themeProp,
    ...otherProps
  } = props;

  const circularIndicatorContext = useContext(CircularProgressIndicatorContext);
  const resolvedTheme = _merge({}, theme ? theme.CIRCULAR_PROGRESS_DETERMINATE : {}, themeProp);

  return (
    <Styled.OuterLabelText
      ref={ref}
      center={circularIndicatorContext.circleSize / 2}
      $theme={resolvedTheme}
      {...otherProps}
    >
      {children}
    </Styled.OuterLabelText>
  );
}));

CircularProgressIndicatorOuterText.defaultProps = {
  theme: {}
};

CircularProgressIndicatorOuterText.displayName = 'CircularProgressIndicatorOuterText';

export default CircularProgressIndicatorOuterText;
